define( [
	"./arr"
], function( arr ) {
	return arr.concat;
} );



//////////////////
// WEBPACK FOOTER
// ./~/jquery/src/var/concat.js
// module id = 638
// module chunks = 214